function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Attachment = function Attachment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M9.135 23.077c-1.834 0-3.667-.7-5.06-2.1-2.776-2.79-2.765-7.318.025-10.094l8.343-8.303a5.44 5.44 0 0 1 7.686.018 5.44 5.44 0 0 1-.02 7.687l-7.661 7.624a3.735 3.735 0 0 1-5.274-.014 3.735 3.735 0 0 1 .012-5.274l5.22-5.195a1 1 0 1 1 1.412 1.418l-5.221 5.195a1.73 1.73 0 0 0-.005 2.446 1.73 1.73 0 0 0 2.446.006l7.66-7.624a3.4 3.4 0 0 0 1.013-2.427 3.4 3.4 0 0 0-1-2.43 3.44 3.44 0 0 0-4.857-.012L5.51 12.3a5.144 5.144 0 0 0-.018 7.267 5.145 5.145 0 0 0 7.266.017l5.932-5.903a1 1 0 0 1 1.41 1.418l-5.931 5.903a7.12 7.12 0 0 1-5.035 2.075"
  }));
};
export default Attachment;